import styled, { css } from "styled-components";

const variants = {
  default: css`
    background: #111827;
    color: white;
    border: 1px solid #111827;

    &:hover {
      background: #1f2937;
    }
  `,

  destructive: css`
    background: #dc2626;
    color: white;
    border: 1px solid #dc2626;

    &:hover {
      background: #b91c1c;
    }
  `,

  outline: css`
    background: transparent;
    border: 1px solid #e5e7eb;
    color: #111827;

    &:hover {
      background: #f3f4f6;
    }
  `,

  secondary: css`
    background: #f3f4f6;
    color: #111827;
    border: 1px solid transparent;

    &:hover {
      background: #e5e7eb;
    }
  `,

  ghost: css`
    background: transparent;
    border: 1px solid transparent;
    color: #111827;

    &:hover {
      background: #f3f4f6;
    }
  `,

  link: css`
    background: transparent;
    border: none;
    color: #2563eb;
    padding: 0;

    &:hover {
      text-decoration: underline;
    }
  `,
};

const sizes = {
  sm: css`
    height: 32px;
    padding: 0 12px;
    font-size: 14px;
  `,
  md: css`
    height: 36px;
    padding: 0 16px;
    font-size: 14px;
  `,
  lg: css`
    height: 40px;
    padding: 0 20px;
    font-size: 16px;
  `,
};

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) => variants[props.variant || "default"] || variants.default}
  ${(props) => sizes[props.size || "md"] || sizes.md}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
